import { render, staticRenderFns } from "./project_detail_base.vue?vue&type=template&id=6ebfacb6&scoped=true&"
import script from "./project_detail_base.vue?vue&type=script&lang=js&"
export * from "./project_detail_base.vue?vue&type=script&lang=js&"
import style0 from "./project_detail_base.vue?vue&type=style&index=0&id=6ebfacb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfacb6",
  null
  
)

export default component.exports